import React from 'react';
import PropTypes from 'prop-types';

const CreateActivityButton = ({ onClick }) => (
  <button
    className="btn btn-label btn-primary w-100"
    id="add-btn"
    onClick={onClick}
  >
    <i className={`${Icons.plus} label-icon`}></i> Crear Nueva Actividad
  </button>
);

CreateActivityButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CreateActivityButton;
